// core concepts https://www.algolia.com/doc/ui-libraries/autocomplete/core-concepts/basic-configuration-options/

import algoliasearch from 'algoliasearch/lite';
import { autocomplete, getAlgoliaResults } from '@algolia/autocomplete-js';
import '@algolia/autocomplete-theme-classic';

export default function algoliaAutocomplete() {
  const cfg = window.algoliaAutocompleteData || {};
  const searchUrl = cfg.searchUrl || '/search';

  const ENABLE_BOX_DOCS = Boolean(cfg.enableBoxDocs);

  const searchClient = algoliasearch(cfg.applicationId, cfg.searchApiKey);

  const today = Math.floor(new Date().setHours(0, 0, 0, 0) / 1000);

  const shouldSearch = (query) => (query || '').trim().length > 2;

  const buildWpFilters = () =>
    [
      `expires_at >= ${today}`,
      `status:"publish"`,
      `language_code:"${cfg.languageCode}"`,
    ].join(' AND ');

  const viewAllUrl = (query) =>
    `${searchUrl}?keywords=${encodeURIComponent((query || '').trim())}`;

  autocomplete({
    container: '#autocomplete',
    placeholder: cfg.searchPlaceholder,
    autoFocus: true,
    detachedMediaQuery: 'none',

    onSubmit({ state }) {
      window.location.href = viewAllUrl(state.query);
    },

    onReset() {
      if (document.activeElement?.closest('.search')) {
        document.querySelector('.site-header')?.classList.remove('search-active');
      }
    },

    render({ state, elements, render, html }, root) {
      const { wp_content, box_docs } = elements;

      render(
        html`<div class="aa-PanelLayout">
          ${wp_content}
          ${ENABLE_BOX_DOCS ? box_docs : null}
          <section class="results-footer">
            <a tabindex="0" href="${viewAllUrl(state.query)}" id="autocompleteViewAllResultsLink">
              ${cfg.searchViewAllResults}
            </a>
          </section>
        </div>`,
        root
      );
    },

    getSources() {

      console.log('algoliaIndexId:', cfg.algoliaIndexId, typeof cfg.algoliaIndexId);
console.log('algoliaIndexId JSON:', JSON.stringify(cfg.algoliaIndexId));
      const sources = [
        {
          sourceId: 'wp_content',
          getItems({ query }) {
            if (!shouldSearch(query)) return [];

            return getAlgoliaResults({
              searchClient,
              queries: [
                {
                  indexName: cfg.algoliaIndexId,
                  query,
                  params: {
                    filters: buildWpFilters(),
                    hitsPerPage: 3,
                  },
                },
              ],
            });
          },
          getItemUrl({ item }) {
            return item.relative_url;
          },
          templates: {
            header({ html }) {
              return html`<div class="results-header">${cfg.searchTypeWebsiteLabel}</div>`;
            },
            item({ item, html }) {
              return html`<div class="search-result">
                <a href="${item.relative_url}">
                  <div class="search-result--page-type">${item.page_type}</div>
                  <div class="search-result--title">${item.title}</div>
                </a>
              </div>`;
            },
          },
        },
      ];

      if (ENABLE_BOX_DOCS) {
        sources.push({
          sourceId: 'box_docs',
          getItems({ query }) {
            if (!shouldSearch(query)) return [];

            return getAlgoliaResults({
              searchClient,
              queries: [
                {
                  indexName: cfg.algoliaBoxDocsIndexId,
                  query,
                  params: {
                    hitsPerPage: 3,
                  },
                },
              ],
            });
          },
          getItemUrl({ item }) {
            return item.url;
          },
          templates: {
            header({ html }) {
              return html`<div class="results-header">${cfg.searchTypeDocumentsLabel}</div>`;
            },
            item({ item, html }) {
              const displayLabel = item?.title?.length ? item.title : item.name;

              return html`<div class="search-result search-result-document">
                <a href="${item.url}">
                  <span class="search-result--icon icon-type-${item.fileType}"></span>
                  <div class="search-result--title">${displayLabel}</div>
                </a>
              </div>`;
            },
          },
        });
      }

      return sources;
    },
  });

  // Move elements around in algolia form (as you had)
  const form = document.querySelector('#autocomplete .aa-Form');
  if (form?.firstElementChild) {
    const firstElement = form.firstElementChild;
    form.removeChild(firstElement);
    form.insertBefore(firstElement, form.lastElementChild);
  }

  const clearButton = form?.querySelector('.aa-ClearButton');
  clearButton?.setAttribute('aria-label', 'Close Search Form');

  clearButton?.addEventListener('click', () => {
    document.querySelector('.aa-Panel')?.remove();
  });
}

algoliaAutocomplete();
